import { atom } from 'recoil';
import { localStorageEffect } from '../utils/localstorage';

export const accessTokenState = atom<string | null>({
    key: 'accessTokenState',
    default: null,
    effects: [localStorageEffect('accessToken')],
});

export const refreshTokenState = atom<string | null>({
    key: 'refreshTokenState',
    default: null,
    effects: [localStorageEffect('refreshToken')],
});

export const expireState = atom<number | null>({
    key: 'expireState',
    default: null,
    effects: [localStorageEffect('expire')],
});

export const updateTimeState = atom<number | null>({
    key: 'updateTimeState',
    default: null,
    effects: [localStorageEffect('updateTime')],
});